import { render, staticRenderFns } from "./MyFavoritesToggle.vue?vue&type=template&id=b1713978&"
import script from "./MyFavoritesToggle.vue?vue&type=script&lang=js&"
export * from "./MyFavoritesToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports